var map = {
	"./Electron_Software_Framework_Logo.svg": 599,
	"./Gallery heading.svg": 773,
	"./Logo black.svg": 313,
	"./Tailwind_CSS_Logo.svg": 554,
	"./Title.svg": 446,
	"./Typescript_logo_2020.svg": 741,
	"./Unofficial_JavaScript_logo_2.svg": 953,
	"./applications/display.png": 842,
	"./applications/display/dashboard.png": 139,
	"./applications/display/landingspage.png": 28,
	"./applications/display/videowatch.png": 22,
	"./applications/pokemon.png": 978,
	"./applications/pokemon/challenger-arrived.png": 23,
	"./applications/pokemon/change-pokemon.png": 192,
	"./applications/pokemon/choose.png": 812,
	"./applications/pokemon/start.png": 776,
	"./applications/record-tracker.png": 398,
	"./applications/recordtracker/dashboard.png": 507,
	"./applications/recordtracker/record-view.png": 212,
	"./applications/recordtracker/search-window.png": 47,
	"./arrow-icon.svg": 774,
	"./designs/koffie-userexperience-thumbnail.png": 420,
	"./designs/pinch-ape-introduction-thumbnail.png": 480,
	"./designs/ramen-restaurant-thumbnail.png": 865,
	"./electron-logo.svg": 671,
	"./email.svg": 168,
	"./github.svg": 405,
	"./iconmonstr-linkedin-3.svg": 890,
	"./landingspage-bubbles.svg": 479,
	"./logo-small.svg": 934,
	"./logo.png": 949,
	"./vue-logo.svg": 786
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;